import styled from 'styled-components';

const ContentArea = styled.div`
  max-width: 936px;
  margin: auto;

  @media (min-width: ${({ theme }) =>
      theme.breakpoints.tablet.minWidth}px) and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet.maxWidth}px) {
    margin-top: 24px;
    max-width: 704px;
  }
`;

export default ContentArea;
